var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87496 12.8311C4.62879 12.8315 4.38495 12.7833 4.15746 12.6893C3.92997 12.5952 3.7233 12.4571 3.54934 12.2829L0.0537109 8.78794L0.937461 7.90357L4.43309 11.3992C4.55029 11.5164 4.70923 11.5822 4.87496 11.5822C5.04069 11.5822 5.19963 11.5164 5.31684 11.3992L14.0625 2.65356L14.9462 3.53731L6.20059 12.2829C6.02662 12.4571 5.81995 12.5952 5.59246 12.6893C5.36497 12.7833 5.12113 12.8315 4.87496 12.8311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b78cc3cb40d24904a164c18b51089604.svg";
export { ForwardRef as ReactComponent };